import React from 'react';
import PropTypes from 'prop-types';
import SearchRow from '../../components/SearchRow';

const SearchPage = ({ ...props }) => {
  return (
    <div id="appcenter-main">
      <div id="appcenter-categories">
        <SearchRow {...props} />
      </div>
    </div>
  );
};

SearchPage.displayName = 'search';

SearchPage.propTypes = {
  fptiClick: PropTypes.func,
  appSearch: PropTypes.object,
  flatPSData: PropTypes.object
};

export default SearchPage;
